<template>
  <div>
    <el-table
      :data="regular.data"
      :highlight-current-row="false"
      :row-class-name="tableRowClassName"
      class="video-tracks-scan"
      v-loading="loading"
    >
      <el-table-column label="Video/Channel" width="300">
        <template slot-scope="props">
          <i class="shorts-icon" v-if="props.row.short === 1"></i>
          <a
            :href="`https://youtube.com/watch?v=${props.row.video_id}`"
            target="_blank"
          >
            {{ props.row.video_title }}
          </a>
          <br />
          <a
            :href="`https://youtube.com/channel/${props.row.channel_id}`"
            target="_blank"
          >
            {{ props.row.channel_name }}
          </a>
          <br />
          <el-tag v-if="props.row.user_tier === 1" type="warning"
            >Bronze</el-tag
          >
          <el-tag v-else-if="props.row.user_tier === 2" type="info"
            >Silver</el-tag
          >
          <el-tag v-else type="primary">Free</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Publish date">
        <template slot-scope="props">
          {{ props.row.video_published | datetimesec }}
        </template>
      </el-table-column>
      <el-table-column label="Artist/Track" width="200">
        <template slot-scope="props">
          {{ props.row.artist_name }}
          <br />
          {{ props.row.track_name }}
        </template>
      </el-table-column>
      <el-table-column label="Leaderboard">
        <template slot-scope="props">
          <el-switch
            v-model="props.row.leaderboard"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="15 sec">
        <template slot-scope="props">
          <el-switch
            v-model="props.row.sec_15"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="30 sec">
        <template slot-scope="props">
          <el-switch
            v-model="props.row.sec_55"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="3rd paragraph" width="100">
        <template slot-scope="props">
          <el-switch
            v-model="props.row.paragraph_3rd"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="Repeating track" width="100">
        <template slot-scope="props">
          <el-switch
            v-model="props.row.repeating_track"
            active-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <br />
          <br />
          <el-tag
            type="danger"
            v-if="
              (props.row.rejected_per_channel > 0 &&
                props.row.first_video != null &&
                props.row.first_video != props.row.video_id) ||
                props.row.approved_per_channel > 1
            "
          >
            Yes
          </el-tag>
          <el-tag type="success" v-else>No</el-tag>
          <el-tooltip
            v-if="props.row.approved_per_channel > 1"
            :content="
              `Track is approved for ${props.row.approved_per_channel} videos on this channel!`
            "
          >
            <i class="el-icon-info ml5"></i>
          </el-tooltip>
          <!-- <el-switch
            v-model="props.row.t_c"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
          ></el-switch> -->
        </template>
      </el-table-column>
      <el-table-column label="Artist credited" width="150">
        <template slot-scope="props">
            <el-checkbox-group v-model="props.row.artist_credited">
              <el-checkbox v-for="r in artist_credited" :key="r" :label="r"></el-checkbox>
            </el-checkbox-group>
        </template>
      </el-table-column>
      <el-table-column label="Where in video" width="150">
        <template slot-scope="props">
          <el-select v-model="props.row.where_in_video" placeholder="Select">
            <el-option v-for="(w, i) in wheres" :key="i" :value="w"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Uninterrupted" width="100">
        <template slot-scope="props">
            <el-input v-model="props.row.uninterruptedSeconds"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Quality" width="180">
        <template slot-scope="props">
          <el-rate v-model="props.row.quality"></el-rate>
        </template>
      </el-table-column>
      <el-table-column label="Admin notes" width="200">
        <template slot-scope="props">
          <el-input type="textarea" v-model="props.row.keywords"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200">
        <template slot-scope="props">
          <el-tooltip content="Approve" v-if="props.row.video_approved !== 1">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="approve(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Reject" v-if="props.row.video_approved !== 0">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="reject(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip v-if="showSaveButton(props.row)" content="Save">
            <el-button
              circle
              size="small"
              icon="el-icon-finished"
              @click="update(props.row)"
            ></el-button>
          </el-tooltip>
          <el-popover placement="left" width="400" trigger="click">
            <el-table :data="trackDuration" class="w100" stripe   v-loading="trackDurationLoader">
              <el-table-column
                  prop="start_time"
                  label="Start Time"
                ><template slot-scope="props">{{props.row.start_time}}</template></el-table-column>
              <el-table-column
                  prop="end_time"
                  label="End Time"
                ><template slot-scope="props">{{props.row.end_time}}</template></el-table-column>
              <el-table-column
                  prop="duration"
                  label="Duration"
                ><template slot-scope="props">{{props.row.duration}}</template></el-table-column>
            </el-table>
            <el-button
              slot="reference"
              circle
              size="small"
              icon="el-icon-set-up"
              @click="
                getTrackDuration({
                  videoId: props.row.video_id,
                  trackId: props.row.track_id
                })"
            ></el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="regular.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="regular.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {

  data() {
    return {
      artist_credited_temp: {},
    }
  },

  props: ['artist_credited'],

  computed: {
    ...mapState('vcVideoTracksScanRegular', [
      'regular',
      'loading',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'wheres',
      'credits',
      'trackDuration',
      'trackDurationLoader'
    ])
  },

  methods: {
    ...mapMutations('vcVideoTracksScanRegular', [
      'setPageRegular',
      'setPageSize',
      'setOrdering'
    ]),
    ...mapActions('vcVideoTracksScanRegular', [
      'readRegular',
      'update',
      'approve',
      'reject',
      'getTrackDuration'
    ]),
    showSaveButton(row) {
      return (
        (row.video_approved !== null && row.approved !== null) ||
        (row.video_approved === null && row.approved === null)
      )
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readRegular()
    },
    currentChange(page) {
      this.setPageRegular(page)
      this.readRegular()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readRegular()
    },
    tableRowClassName({ row }) {
      if (row.video_approved === 1) {
        return 'green-row'
      } else if (row.video_approved === 0) {
        return 'red-row'
      } else if (
        (row.rejected_per_channel > 0 &&
          row.first_video != null &&
          row.first_video != row.video_id) ||
        row.approved_per_channel > 1
      ) {
        return 'grey-row'
      }
      if (row.approved === 1) return 'yellow-row'
      if (row.approved === 0) return 'red-row'
      return ''
    },
  },

  created() {
    this.readRegular()
  }
}
</script>

<style>
.el-table tr.green-row {
  background-color: #d6f3d6;
}
.el-table tr.red-row {
  background-color: #ffeded;
}
.el-table tr.grey-row {
  background-color: #bdbdbd;
}
.el-table tr.yellow-row {
  background-color: #fcf1dc;
}
.video-tracks-scan.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent;
}
</style>
